import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchTourPackageById, updateTourPackage } from '../redux/slices/packageSlice';
import { toast } from 'react-toastify';
import AdminSidebar from '../Components/AdminSidebar';
import { PencilIcon } from '@heroicons/react/solid';

const EditPackage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { currentPackage, loading, error } = useSelector((state) => state.package || {});
    const tourPackage = currentPackage?.tourPackage || {};
    const [activeSection, setActiveSection] = useState('createPackage');
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        tourType: '',
        rating: '',
        reviewCount: '',
        duration: '',
        inclusions: [
            { label: 'Transfer Included', icon: 'M8 16l4-4m0 0l4 4m-4-4V4' },
            { label: 'Stay Included', icon: 'M3 12h18m-9-9v18' },
            { label: 'Breakfast Included', icon: 'M12 8v4l3 3' },
            {
                label: 'Sightseeing Included',
                icon: [
                    'M15 12a3 3 0 11-6 0 3 3 0 016 0z',
                    'M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542-7-4.477 0-8.268-2.943-9.542-7z',
                ],
            },
            { label: 'Guide', icon: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2v6h4v-6c0-1.1-.9-2-2-2z' },
        ],
        images: [{ url: '', file: null, alt: '', label: '' }],
        durationOptions: [{
            days: '',
            originalPrice: '',
            discountedPrice: '',
            image: '',
            destinations: [''],
            route: '',
            highlights: [''],
            inclusionExclusions: [{ label: '', category: 'inclusion' }],
            knowBeforeYouGo: [{ tip: '' }],
            itineraries: [{
                day: 'Day 1',
                title: '',
                description: '',
                transferFrom: '',
                transferStop: '',
                transferTo: '',
                checkInTime: '',
                checkOutTime: '',
                sharedTransfer: { type: 'Transfer in Coach' },
                hotels: [{ name: '', rating: '', image: null }],
                inclusions: { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                activity: { name: '', image: null },
            }],
        }],
    });
    const [originalData, setOriginalData] = useState(null);
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        dispatch(fetchTourPackageById(id));
    }, [dispatch, id]);

    useEffect(() => {
        console.log('tourPackage:', tourPackage);
        if (tourPackage && Object.keys(tourPackage).length > 0) {
            const data = {
                title: tourPackage.title || '',
                tourType: tourPackage.tourType || '',
                rating: tourPackage.rating || '',
                reviewCount: tourPackage.reviewCount || '',
                duration: tourPackage.duration || '',
                inclusions: Array.isArray(tourPackage.inclusions) && tourPackage.inclusions.length > 0
                    ? tourPackage.inclusions
                    : formData.inclusions,
                images: Array.isArray(tourPackage.images) && tourPackage.images.length > 0
                    ? tourPackage.images.map(img => ({
                        url: img.url || '',
                        file: null,
                        alt: img.alt || '',
                        label: img.label || '',
                    }))
                    : [{ url: '', file: null, alt: '', label: '' }],
                durationOptions: Array.isArray(tourPackage.durationOptions) && tourPackage.durationOptions.length > 0
                    ? tourPackage.durationOptions.map((opt, index) => ({
                        days: opt.days || '',
                        originalPrice: opt.originalPrice || '',
                        discountedPrice: opt.discountedPrice || '',
                        image: opt.image || '',
                        destinations: Array.isArray(opt.destinations) && opt.destinations.length > 0 ? opt.destinations : [''],
                        route: opt.route || '',
                        highlights: Array.isArray(opt.highlights) && opt.highlights.length > 0 ? opt.highlights : [''],
                        inclusionExclusions: Array.isArray(opt.inclusionExclusions) && opt.inclusionExclusions.length > 0
                            ? opt.inclusionExclusions.map(item => ({
                                label: item.label || item.text || item.value || '',
                                category: item.category || 'inclusion',
                                _id: item._id || undefined,
                            }))
                            : [{ label: '', category: 'inclusion' }],
                        knowBeforeYouGo: Array.isArray(opt.knowBeforeYouGo) && opt.knowBeforeYouGo.length > 0
                            ? opt.knowBeforeYouGo.map(item => ({
                                tip: item.tip || item.label || item.text || item.value || '',
                                _id: item._id || undefined,
                            }))
                            : [{ tip: '' }],
                        itineraries: Array.isArray(opt.itineraries) && opt.itineraries.length > 0
                            ? opt.itineraries.map((it, index) => ({
                                day: it.day || `Day ${index + 1}`,
                                title: it.title || '',
                                description: it.description || '',
                                transferFrom: it.sharedTransfer?.from || it.transferFrom || '',
                                transferStop: it.sharedTransfer?.stop || it.transferStop || '',
                                transferTo: it.sharedTransfer?.to || it.transferTo || '',
                                checkInTime: it.checkInTime || '',
                                checkOutTime: it.checkOutTime || '',
                                sharedTransfer: {
                                    type: it.sharedTransfer?.type || 'Transfer in Coach',
                                    from: it.sharedTransfer?.from || it.transferFrom || '',
                                    stop: it.sharedTransfer?.stop || it.transferStop || '',
                                    to: it.sharedTransfer?.to || it.transferTo || '',
                                },
                                hotels: Array.isArray(it.hotels) && it.hotels.length > 0
                                    ? it.hotels.map(h => ({
                                        name: h.name || '',
                                        rating: h.rating || '',
                                        image: h.image || null,
                                    }))
                                    : [{ name: '', rating: '', image: null }],
                                inclusions: it.inclusions || { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                                activity: { name: it.activity?.name || '', image: it.activity?.image || null },
                            }))
                            : [{
                                day: 'Day 1',
                                title: '',
                                description: '',
                                transferFrom: '',
                                transferStop: '',
                                transferTo: '',
                                checkInTime: '',
                                checkOutTime: '',
                                sharedTransfer: { type: 'Transfer in Coach' },
                                hotels: [{ name: '', rating: '', image: null }],
                                inclusions: { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                                activity: { name: '', image: null },
                            }],
                    }))
                    : [{
                        days: '',
                        originalPrice: '',
                        discountedPrice: '',
                        image: '',
                        destinations: [''],
                        route: '',
                        highlights: [''],
                        inclusionExclusions: [{ label: '', category: 'inclusion' }],
                        knowBeforeYouGo: [{ tip: '' }],
                        itineraries: [{
                            day: 'Day 1',
                            title: '',
                            description: '',
                            transferFrom: '',
                            transferStop: '',
                            transferTo: '',
                            checkInTime: '',
                            checkOutTime: '',
                            sharedTransfer: { type: 'Transfer in Coach' },
                            hotels: [{ name: '', rating: '', image: null }],
                            inclusions: { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                            activity: { name: '', image: null },
                        }],
                    }],
            };
            setFormData(data);
            setOriginalData(data);
        }
    }, [tourPackage]);

    const validateForm = () => {
        const errors = [];
        formData.durationOptions.forEach((opt, idx) => {
            if (!opt.days || isNaN(opt.days) || opt.days <= 0) {
                errors.push(`Days for duration option ${idx + 1} must be a positive number.`);
            }
            if (!opt.originalPrice || isNaN(opt.originalPrice) || opt.originalPrice <= 0) {
                errors.push(`Original price for duration option ${idx + 1} must be a positive number.`);
            }
            if (!opt.discountedPrice || isNaN(opt.discountedPrice) || opt.discountedPrice <= 0) {
                errors.push(`Discounted price for duration option ${idx + 1} must be a positive number.`);
            }
            if (!opt.destinations?.length) {
                errors.push(`At least one destination is required for duration option ${idx + 1}.`);
            }
            if (!opt.highlights?.length) {
                errors.push(`At least one highlight is required for duration option ${idx + 1}.`);
            }
            if (!opt.route?.trim()) {
                errors.push(`Route is required for duration option ${idx + 1}.`);
            }
            if (!opt.inclusionExclusions?.length) {
                errors.push(`At least one inclusion/exclusion is required for duration option ${idx + 1}.`);
            }
            if (!opt.knowBeforeYouGo?.length) {
                errors.push(`At least one knowBeforeYouGo tip is required for duration option ${idx + 1}.`);
            }
            opt.itineraries?.forEach((it, itIdx) => {
                if (!it.hotels?.length) {
                    errors.push(`At least one hotel is required for itinerary ${itIdx + 1} in duration option ${idx + 1}.`);
                }
                it.hotels?.forEach((hotel, hIdx) => {
                    if (!hotel.image) {
                        errors.push(`Hotel image is required for itinerary ${itIdx + 1}, hotel ${hIdx + 1} in duration option ${idx + 1}.`);
                    }
                });
                if (!it.activity?.image) {
                    errors.push(`Activity image is required for itinerary ${itIdx + 1} in duration option ${idx + 1}.`);
                }
            });
        });
        return errors;
    };

    const handleInputChange = (e) => {
        if (!isEditing) return;
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name.includes('Price') || name === 'rating' || name === 'reviewCount' ? parseFloat(value) || '' : value,
        }));
        setValidationErrors([]);
    };

    const handleDurationOptionFieldChange = (optIndex, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? { ...opt, [field]: field === 'days' || field === 'originalPrice' || field === 'discountedPrice' ? parseFloat(value) || '' : value }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleDurationOptionArrayChange = (optIndex, field, index, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? { ...opt, [field]: opt[field]?.map((item, j) => (j === index ? value : item)) || opt[field] }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleInclusionExclusionChange = (optIndex, index, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        inclusionExclusions: opt.inclusionExclusions?.map((item, j) =>
                            j === index ? { ...item, [field]: value } : item
                        ) || opt.inclusionExclusions,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleKnowBeforeYouGoChange = (optIndex, index, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        knowBeforeYouGo: opt.knowBeforeYouGo?.map((item, j) =>
                            j === index ? { ...item, tip: value } : item
                        ) || opt.knowBeforeYouGo,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleImageChange = (index, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            images: prev.images?.map((img, i) =>
                i === index ? { ...img, [field]: value } : img
            ) || prev.images,
        }));
        setValidationErrors([]);
    };

    const handleDurationOptionImageChange = (optIndex, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex ? { ...opt, image: value } : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleItineraryChange = (optIndex, itIndex, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex ? { ...it, [field]: value } : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleHotelChange = (optIndex, itIndex, hotelIndex, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex
                                ? {
                                    ...it,
                                    hotels: it.hotels?.map((h, hIdx) =>
                                        hIdx === hotelIndex
                                            ? { ...h, [field]: field === 'rating' ? parseFloat(value) || '' : value }
                                            : h
                                    ) || it.hotels,
                                }
                                : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleInclusionChange = (optIndex, itIndex, meal, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex
                                ? { ...it, inclusions: { ...it.inclusions, [meal]: value } }
                                : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleActivityChange = (optIndex, itIndex, field, value) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex
                                ? { ...it, activity: { ...it.activity, [field]: value } }
                                : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const addArrayItem = (field, optIndex = null) => {
        if (!isEditing) return;
        if (optIndex !== null) {
            setFormData((prev) => ({
                ...prev,
                durationOptions: prev.durationOptions?.map((opt, i) =>
                    i === optIndex
                        ? {
                            ...opt,
                            [field]:
                                field === 'destinations' || field === 'highlights'
                                    ? [...(opt[field] || []), '']
                                    : field === 'inclusionExclusions'
                                        ? [...(opt[field] || []), { label: '', category: 'inclusion' }]
                                        : [...(opt[field] || []), { tip: '' }],
                        }
                        : opt
                ) || prev.durationOptions,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [field]:
                    field === 'images'
                        ? [...(prev[field] || []), { url: '', file: null, alt: '', label: '' }]
                        : [...(prev[field] || []), {
                            days: '',
                            originalPrice: '',
                            discountedPrice: '',
                            image: '',
                            destinations: [''],
                            route: '',
                            highlights: [''],
                            inclusionExclusions: [{ label: '', category: 'inclusion' }],
                            knowBeforeYouGo: [{ tip: '' }],
                            itineraries: [{
                                day: 'Day 1',
                                title: '',
                                description: '',
                                transferFrom: '',
                                transferStop: '',
                                transferTo: '',
                                checkInTime: '',
                                checkOutTime: '',
                                sharedTransfer: { type: 'Transfer in Coach' },
                                hotels: [{ name: '', rating: '', image: null }],
                                inclusions: { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                                activity: { name: '', image: null },
                            }],
                        }],
            }));
        }
        setValidationErrors([]);
    };

    // Example: Adding a new itinerary
    const addItinerary = (durationIndex) => {
        setFormData((prev) => {
            const newDurationOptions = [...prev.durationOptions];
            newDurationOptions[durationIndex].itineraries.push({
                day: `Day ${newDurationOptions[durationIndex].itineraries.length + 1}`,
                title: '',
                description: '',
                transferFrom: '',
                transferStop: '',
                transferTo: '',
                checkInTime: '',
                checkOutTime: '',
                hotels: [{ name: '', rating: '', image: '' }], // Initialize with empty string or placeholder URL
                inclusions: { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                activity: { name: '', image: '' }, // Initialize with empty string or placeholder URL
            });
            return { ...prev, durationOptions: newDurationOptions };
        });
    };

    const addHotel = (optIndex, itIndex) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex
                                ? { ...it, hotels: [...(it.hotels || []), { name: '', rating: '', image: null }] }
                                : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const removeArrayItem = (field, index, optIndex = null) => {
        if (!isEditing) return;
        if (optIndex !== null) {
            setFormData((prev) => ({
                ...prev,
                durationOptions: prev.durationOptions?.map((opt, i) =>
                    i === optIndex
                        ? { ...opt, [field]: opt[field]?.filter((_, j) => j !== index) || opt[field] }
                        : opt
                ) || prev.durationOptions,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [field]: prev[field]?.filter((_, i) => i !== index) || prev[field],
            }));
        }
        setValidationErrors([]);
    };

    const removeItinerary = (optIndex, itIndex) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries
                            ?.filter((_, j) => j !== itIndex)
                            .map((it, j) => ({ ...it, day: `Day ${j + 1}` })) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const removeHotel = (optIndex, itIndex, hotelIndex) => {
        if (!isEditing) return;
        setFormData((prev) => ({
            ...prev,
            durationOptions: prev.durationOptions?.map((opt, i) =>
                i === optIndex
                    ? {
                        ...opt,
                        itineraries: opt.itineraries?.map((it, j) =>
                            j === itIndex
                                ? { ...it, hotels: it.hotels?.filter((_, hIdx) => hIdx !== hotelIndex) || it.hotels }
                                : it
                        ) || opt.itineraries,
                    }
                    : opt
            ) || prev.durationOptions,
        }));
        setValidationErrors([]);
    };

    const handleSubmit = async () => {
        if (!isEditing) return;
        toast.dismiss();
        setValidationErrors([]);

        if (!validateForm()) {
            validationErrors.forEach((err) =>
                toast.error(err, {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                })
            );
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('title', formData.title || '');
        formDataToSend.append('tourType', formData.tourType || '');
        formDataToSend.append('rating', formData.rating || '');
        formDataToSend.append('reviewCount', formData.reviewCount || '');
        formDataToSend.append('duration', formData.duration || '');
        formDataToSend.append('inclusions', JSON.stringify(formData.inclusions || []));

        formDataToSend.append(
            'images',
            JSON.stringify(
                (formData.images || []).map((img) => ({
                    url: img.file ? '' : img.url || '',
                    alt: img.alt || 'Tour image',
                    label: img.label || '',
                }))
            )
        );
        (formData.images || []).forEach((img) => {
            if (img.file) formDataToSend.append('images', img.file);
        });

        formDataToSend.append(
            'durationOptions',
            JSON.stringify(
                (formData.durationOptions || []).map((opt) => ({
                    days: parseInt(opt.days) || 0,
                    originalPrice: parseFloat(opt.originalPrice) || 0,
                    discountedPrice: parseFloat(opt.discountedPrice) || 0,
                    image: typeof opt.image === 'string' && opt.image.startsWith('http') ? opt.image : '',
                    destinations: (opt.destinations || []).filter((d) => d?.trim()),
                    route: opt.route || '',
                    highlights: (opt.highlights || []).filter((h) => h?.trim()),
                    inclusionExclusions: (opt.inclusionExclusions || []).map((ie) => ({
                        label: ie.label || '',
                        category: ie.category || 'inclusion',
                        _id: ie._id || undefined,
                    })),
                    knowBeforeYouGo: (opt.knowBeforeYouGo || []).map((k) => ({
                        tip: k.tip || '',
                        _id: k._id || undefined,
                    })),
                    itineraries: (opt.itineraries || []).map((it) => ({
                        day: it.day || `Day ${opt.itineraries.indexOf(it) + 1}`,
                        title: it.title || '',
                        description: it.description || '',
                        sharedTransfer: {
                            from: it.transferFrom || '',
                            stop: it.transferStop || '',
                            to: it.transferTo || '',
                            type: it.sharedTransfer?.type || 'Transfer in Coach',
                        },
                        checkInTime: it.checkInTime || '',
                        checkOutTime: it.checkOutTime || '',
                        hotels: (it.hotels || []).map((h) => ({
                            name: h.name || '',
                            rating: h.rating || '',
                            image: h.image && typeof h.image === 'string' && h.image.startsWith('http') ? h.image : undefined,
                        })),
                        inclusions: it.inclusions || { breakfast: 'Included', lunch: 'Not Included', dinner: 'Not Included' },
                        activity: {
                            name: it.activity?.name || '',
                            image: it.activity.image && typeof it.activity.image === 'string' && it.activity.image.startsWith('http') ? it.activity.image : undefined,
                        },
                    })),
                }))
            )
        );
        (formData.durationOptions || []).forEach((opt, optIndex) => {
            if (opt.image && typeof opt.image !== 'string') formDataToSend.append('durationOptionsImages', opt.image);
            (opt.itineraries || []).forEach((it) => {
                (it.hotels || []).forEach((hotel) => {
                    if (hotel.image && typeof hotel.image !== 'string') formDataToSend.append('itineraryHotelImages', hotel.image);
                });
                if (it.activity?.image && typeof it.activity.image !== 'string') formDataToSend.append('itineraryActivityImages', it.activity.image);
            });
        });

        try {
            await dispatch(updateTourPackage({ id, formData: formDataToSend })).unwrap();
            toast.success('Tour package updated successfully!', {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsEditing(false);
        } catch (err) {
            toast.error(err.message || 'Failed to update package.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    const handleCancel = () => {
        setFormData(originalData || formData);
        setIsEditing(false);
        setValidationErrors([]);
    };

    if (error) {
        return (
            <div className="flex min-h-screen bg-gray-100">
                <AdminSidebar />
                <div className="flex-1 p-8 flex items-center justify-center">
                    <div className="text-red-600 text-lg font-semibold">
                        Error: {error}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen bg-gray-100">
            <AdminSidebar setActiveSection={setActiveSection} activeSection={activeSection} />
            <div className="ml-72 flex-1 px-6 py-8">
                <h1 className="pb-6 ml-2 text-lg font-semibold text-gray-800">Edit Package</h1>
                {!isEditing && (
                    <button
                        onClick={() => setIsEditing(true)}
                        className="mb-4 text-blue-500 hover:underline flex items-center"
                    >
                        <PencilIcon className="h-5 w-5 mr-1" /> Edit
                    </button>
                )}
                <div className="space-y-8 max-w-3xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Package Title</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title || ''}
                                onChange={handleInputChange}
                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                placeholder="e.g., Hello Tour | FREE Excursion"
                                disabled={!isEditing}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Package Type</label>
                            <select
                                name="tourType"
                                value={formData.tourType || ''}
                                onChange={handleInputChange}
                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                disabled={!isEditing}
                                required
                            >
                                <option value="" disabled>Select package type</option>
                                <option value="Domestic">Domestic</option>
                                <option value="International">International</option>
                                <option value="Short">Short</option>
                                <option value="Customised">Customised</option>
                                <option value="Activities">Activities</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Rating (0-5)</label>
                            <input
                                type="number"
                                name="rating"
                                value={formData.rating || ''}
                                onChange={handleInputChange}
                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                step="0.1"
                                min="0"
                                max="5"
                                disabled={!isEditing}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Review Count</label>
                            <input
                                type="number"
                                name="reviewCount"
                                value={formData.reviewCount || ''}
                                onChange={handleInputChange}
                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                min="0"
                                disabled={!isEditing}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Duration</label>
                            <input
                                type="text"
                                name="duration"
                                value={formData.duration || ''}
                                onChange={handleInputChange}
                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                placeholder="e.g., 6D/5N"
                                disabled={!isEditing}
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Package Images</label>
                        <div className="flex flex-wrap gap-4">
                            {(formData.images || []).map((img, index) => (
                                <div key={index} className="w-40">
                                    {img.url && (
                                        <img src={img.url} alt={img.alt || 'Tour image'} className="w-32 h-32 object-cover mb-2" />
                                    )}
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(index, 'file', e.target.files[0])}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        disabled={!isEditing}
                                    />
                                    {img.file && (
                                        <p className="text-sm text-gray-600 mt-1">{img.file.name}</p>
                                    )}
                                    {isEditing && (formData.images || []).length > 1 && (
                                        <button
                                            type="button"
                                            onClick={() => removeArrayItem('images', index)}
                                            className="ml-2 text-red-500 hover:text-red-700"
                                        >
                                            Remove Image
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                        {isEditing && (
                            <button
                                type="button"
                                onClick={() => addArrayItem('images')}
                                className="text-blue-500 hover:underline mt-2"
                            >
                                Add Image
                            </button>
                        )}
                    </div>

                    {(formData.durationOptions || []).map((option, optIndex) => (
                        <div key={optIndex} className="border-t pt-6">
                            <hr className="border-2 border-black" />

                            <h2 className="text-lg font-semibold text-gray-800 mb-4">Duration Option {optIndex + 1}</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Days</label>
                                    <input
                                        type="number"
                                        value={option.days || ''}
                                        onChange={(e) => handleDurationOptionFieldChange(optIndex, 'days', e.target.value)}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Days"
                                        min="1"
                                        disabled={!isEditing}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Original Price (INR)</label>
                                    <input
                                        type="number"
                                        value={option.originalPrice || ''}
                                        onChange={(e) => handleDurationOptionFieldChange(optIndex, 'originalPrice', e.target.value)}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="e.g., 226100"
                                        min="0"
                                        step="0.01"
                                        disabled={!isEditing}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Discounted Price (INR)</label>
                                    <input
                                        type="number"
                                        value={option.discountedPrice || ''}
                                        onChange={(e) => handleDurationOptionFieldChange(optIndex, 'discountedPrice', e.target.value)}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="e.g., 170000"
                                        min="0"
                                        step="0.01"
                                        disabled={!isEditing}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Image</label>
                                    {option.image && typeof option.image === 'string' && (
                                        <img src={option.image} alt="Duration Option" className="w-32 h-32 object-cover mb-2" />
                                    )}
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleDurationOptionImageChange(optIndex, e.target.files[0])}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        disabled={!isEditing}
                                    />
                                    {option.image && typeof option.image !== 'string' && (
                                        <p className="text-sm text-gray-600 mt-1">{option.image.name}</p>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Destinations</label>
                                    {(option.destinations || []).map((dest, index) => (
                                        <div key={index} className="flex items-center mb-2">
                                            <input
                                                type="text"
                                                value={dest || ''}
                                                onChange={(e) => handleDurationOptionArrayChange(optIndex, 'destinations', index, e.target.value)}
                                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="e.g., 1 Day in Oslo"
                                                disabled={!isEditing}
                                                required
                                            />
                                            {isEditing && (option.destinations || []).length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeArrayItem('destinations', index, optIndex)}
                                                    className="ml-2 text-red-500 hover:text-red-700"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {isEditing && (
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('destinations', optIndex)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Add Destination
                                        </button>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Route</label>
                                    <input
                                        type="text"
                                        value={option.route || ''}
                                        onChange={(e) => handleDurationOptionFieldChange(optIndex, 'route', e.target.value)}
                                        className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="e.g., Oslo → Stockholm → Helsinki"
                                        disabled={!isEditing}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Highlights</label>
                                    {(option.highlights || []).map((highlight, index) => (
                                        <div key={index} className="flex items-center mb-2">
                                            <input
                                                type="text"
                                                value={highlight || ''}
                                                onChange={(e) => handleDurationOptionArrayChange(optIndex, 'highlights', index, e.target.value)}
                                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                placeholder={`Highlight ${index + 1}`}
                                                disabled={!isEditing}
                                                required
                                            />
                                            {isEditing && (option.highlights || []).length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeArrayItem('highlights', index, optIndex)}
                                                    className="ml-2 text-red-500 hover:text-red-700"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {isEditing && (
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('highlights', optIndex)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Add Highlight
                                        </button>
                                    )}
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700">Inclusions & Exclusions</label>
                                    {(option.inclusionExclusions || []).map((item, index) => (
                                        <div key={index} className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 mb-4 bg-gray-50 p-4 rounded-md border border-gray-200">
                                            <input
                                                type="text"
                                                value={item.label || ''}
                                                onChange={(e) => handleInclusionExclusionChange(optIndex, index, 'label', e.target.value)}
                                                className="w-full sm:w-2/3 p-3 border border-gray-300 rounded-md focus:ring-custom-yellow focus:border-custom-yellow"
                                                placeholder="e.g., Visa assistance"
                                                disabled={!isEditing}
                                                required
                                            />
                                            <select
                                                value={item.category || 'inclusion'}
                                                onChange={(e) => handleInclusionExclusionChange(optIndex, index, 'category', e.target.value)}
                                                className="w-full sm:w-1/3 p-3 border border-gray-300 rounded-md focus:ring-custom-yellow focus:border-custom-yellow"
                                                disabled={!isEditing}
                                                required
                                            >
                                                <option value="inclusion">Inclusion</option>
                                                <option value="exclusion">Exclusion</option>
                                            </select>
                                            {isEditing && (option.inclusionExclusions || []).length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeArrayItem('inclusionExclusions', index, optIndex)}
                                                    className="mt-2 sm:mt-0 text-red-600 hover:text-red-800 transition-colors"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {isEditing && (
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('inclusionExclusions', optIndex)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Add Inclusion/Exclusion
                                        </button>
                                    )}
                                </div>
                                <div className="col-span-2">
                                    <label className="block text-sm font-medium text-gray-700">Know Before You Go</label>
                                    {(option.knowBeforeYouGo || []).map((item, index) => (
                                        <div key={index} className="flex items-center mb-4 bg-white p-4 rounded-md border border-gray-200">
                                            <input
                                                type="text"
                                                value={item.tip || ''}
                                                onChange={(e) => handleKnowBeforeYouGoChange(optIndex, index, e.target.value)}
                                                className="w-full p-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="e.g., Bring comfortable shoes"
                                                disabled={!isEditing}
                                                required
                                            />
                                            {isEditing && (option.knowBeforeYouGo || []).length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeArrayItem('knowBeforeYouGo', index, optIndex)}
                                                    className="ml-2 text-red-600 hover:text-red-800 transition-colors"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {isEditing && (
                                        <button
                                            type="button"
                                            onClick={() => addArrayItem('knowBeforeYouGo', optIndex)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Add Know Before You Go
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="border-t pt-6">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">Itineraries</h3>
                                {(option.itineraries || []).map((itinerary, itIndex) => (
                                    <div key={itIndex} className="border p-4 rounded-md mb-4 bg-white">
                                        <div className="flex justify-between items-center mb-2">
                                            <h4 className="text-lg font-semibold text-blue-600">{itinerary.day}</h4>
                                            {isEditing && (option.itineraries || []).length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeItinerary(optIndex, itIndex)}
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    Remove Day
                                                </button>
                                            )}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Day</label>
                                            <p className="mt-1 w-full p-2 bg-gray-100 rounded-md text-gray-700">
                                                {itinerary.day}
                                            </p>
                                        </div>
                                        <input
                                            type="text"
                                            value={itinerary.title || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'title', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="e.g., Arrival in Copenhagen"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <textarea
                                            value={itinerary.description || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'description', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Description"
                                            rows="4"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <input
                                            type="text"
                                            value={itinerary.transferFrom || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'transferFrom', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Transfer From"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <input
                                            type="text"
                                            value={itinerary.transferStop || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'transferStop', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Transfer Stop"
                                            disabled={!isEditing}
                                        />
                                        <input
                                            type="text"
                                            value={itinerary.transferTo || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'transferTo', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Transfer To"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <input
                                            type="text"
                                            value={itinerary.checkInTime || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'checkInTime', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Check-In Time (e.g., 2:00 PM)"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <input
                                            type="text"
                                            value={itinerary.checkOutTime || ''}
                                            onChange={(e) => handleItineraryChange(optIndex, itIndex, 'checkOutTime', e.target.value)}
                                            className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                            placeholder="Check-Out Time (e.g., 11:00 AM)"
                                            disabled={!isEditing}
                                            required
                                        />
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Hotels</label>
                                            {(itinerary.hotels || []).map((hotel, hIndex) => (
                                                <div key={hIndex} className="flex space-x-2 mb-2">
                                                    <input
                                                        type="text"
                                                        value={hotel.name || ''}
                                                        onChange={(e) => handleHotelChange(optIndex, itIndex, hIndex, 'name', e.target.value)}
                                                        className="mt-1 w-1/3 p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Hotel Name"
                                                        disabled={!isEditing}
                                                        required
                                                    />
                                                    <input
                                                        type="number"
                                                        value={hotel.rating || ''}
                                                        onChange={(e) => handleHotelChange(optIndex, itIndex, hIndex, 'rating', e.target.value)}
                                                        className="mt-1 w-1/4 p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Rating (e.g., 4.5)"
                                                        min="0"
                                                        step="0.1"
                                                        disabled={!isEditing}
                                                        required
                                                    />
                                                    <div className="mt-1 w-1/2">
                                                        {hotel.image && typeof hotel.image === 'string' && (
                                                            <img src={hotel.image} alt="Hotel" className="w-32 h-32 object-cover mb-2" />
                                                        )}
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleHotelChange(optIndex, itIndex, hIndex, 'image', e.target.files[0] || null)}
                                                            className="w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                            disabled={!isEditing}
                                                        />
                                                        {hotel.image && typeof hotel.image !== 'string' && (
                                                            <p className="text-sm text-gray-600 mt-1">{hotel.image.name}</p>
                                                        )}
                                                    </div>
                                                    {isEditing && (itinerary.hotels || []).length > 1 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeHotel(optIndex, itIndex, hIndex)}
                                                            className="ml-2 text-red-500 hover:text-red-700"
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            {isEditing && (
                                                <button
                                                    type="button"
                                                    onClick={() => addHotel(optIndex, itIndex)}
                                                    className="text-blue-500 hover:underline"
                                                    disabled={!isEditing}
                                                >
                                                    Add Hotel
                                                </button>
                                            )}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Inclusions</label>
                                            <div className="flex space-x-4">
                                                {['breakfast', 'lunch', 'dinner'].map((meal) => (
                                                    <div key={meal} className="flex items-center">
                                                        <label className="mr-2 capitalize">{meal}</label>
                                                        <select
                                                            value={itinerary.inclusions?.[meal] || 'Not Included'}
                                                            onChange={(e) => handleInclusionChange(optIndex, itIndex, meal, e.target.value)}
                                                            className="p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                            disabled={!isEditing}
                                                        >
                                                            <option>Included</option>
                                                            <option>Not Included</option>
                                                        </select>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Activity</label>
                                            <input
                                                type="text"
                                                value={itinerary.activity?.name || ''}
                                                onChange={(e) => handleActivityChange(optIndex, itIndex, 'name', e.target.value)}
                                                className="mt-1 w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                                placeholder="Activity Name"
                                                disabled={!isEditing}
                                                required
                                            />
                                            <div className="mt-1">
                                                {itinerary.activity?.image && typeof itinerary.activity.image === 'string' && (
                                                    <img src={itinerary.activity.image} alt="Activity" className="w-32 h-32 object-cover mb-2" />
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleActivityChange(optIndex, itIndex, 'image', e.target.files[0] || null)}
                                                    className="w-full p-2 border rounded-md focus:ring-blue-500 focus:border-blue-500 mb-2"
                                                    disabled={!isEditing}
                                                />
                                                {itinerary.activity?.image && typeof itinerary.activity.image !== 'string' && (
                                                    <p className="text-sm text-gray-600 mt-1">{itinerary.activity.image.name}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {isEditing && (
                                    <button
                                        type="button"
                                        onClick={() => addItinerary(optIndex)}
                                        className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 transition-colors"
                                    >
                                        Add Another Day
                                    </button>
                                )}
                            </div>
                            {isEditing && (formData.durationOptions || []).length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removeArrayItem('durationOptions', optIndex)}
                                    className="text-red-500 hover:text-red-700 mt-4"
                                >
                                    Remove Duration Option
                                </button>
                            )}
                        </div>
                    ))}
                    {isEditing && (
                        <button
                            type="button"
                            onClick={() => addArrayItem('durationOptions')}
                            className="text-blue-500 hover:underline mt-4"
                        >
                            Add Duration Option
                        </button>
                    )}
                    {isEditing && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={loading}
                                className={`w-full p-3 rounded-md font-medium transition-colors ${loading
                                    ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                                    : 'bg-blue-500 text-white hover:bg-blue-600'
                                    }`}
                                aria-disabled={loading}
                            >
                                {loading ? 'Updating...' : 'Save Changes'}
                            </button>
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="w-full p-3 rounded-md font-medium bg-gray-300 text-gray-700 hover:bg-gray-400 transition-colors"
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EditPackage;